// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"a4e9e769","316":"8071311d","591":"9f2514d1","647":"6c763a9c","759":"dc1cdbe9","848":"6f67ba54"}[chunkId] + ".chunk.css";
};